import { format } from 'date-fns/fp';
import { pipe } from 'lodash/fp';
import { DATE_FORMAT } from '../../constants';
import ensureParseISO from './ensureParseISO';
export var formatDate = pipe(ensureParseISO, format(DATE_FORMAT));
export default formatDate;